import React from 'react';

export const BulletOne = () => (
    <svg
        width="8"
        height="9"
        viewBox="0 0 8 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.43359 0L-3.52854e-05 3.13519L2.71686 8.25145L7.15049 5.11626L4.43359 0Z"
            fill="#D09FD8"
        />
    </svg>
);

export const BulletTwo = () => (
    <svg
        width="8"
        height="10"
        viewBox="0 0 8 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.22314 0L-8.46416e-05 6.51302L5.64462 9.079L7.86785 2.56598L2.22314 0Z"
            fill="#982EA9"
        />
    </svg>
);

export const BulletThree = () => (
    <svg
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.80542 5.70581L4.94559 1.90483e-05L-0.000119688 5.60727L4.85971 11.3131L9.80542 5.70581Z"
            fill="#B394F2"
        />
    </svg>
);

export const BulletFour = () => (
    <svg
        width="9"
        height="11"
        viewBox="0 0 9 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.81689 8.13989L6.55892 0.574086L7.32022e-05 3.16776L2.25804 10.7336L8.81689 8.13989Z"
            fill="#D09FD8"
        />
    </svg>
);

export const BulletFive = () => (
    <svg
        width="8"
        height="9"
        viewBox="0 0 8 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.74438 2.33643L2.02561 2.77353e-05L0.000114334 6.59872L5.71889 8.93512L7.74438 2.33643Z"
            fill="#B394F2"
        />
    </svg>
);
